import {
  EDIT_PAYMENT_INFO,
  REQUEST_CANCEL_SCHEDULED_PAYMENT,
  REQUEST_INITIATE_PAYMENT,
  SAVE_DATE_OF_BIRTH,
  SAVE_FIRST_NAME,
  SAVE_LAST_NAME,
  SAVE_PAYMENT_INFO,
} from '@renter-hub/constants/actionTypes';
import requestStatus from '@common/constants/requestStatus';

const initState = {
  rentDetails: {
    name: '',
    email: '',
    address: '',
    amount: '',
    firstDueDate: '',
    renterFirstName: '',
    renterLastName: '',
  },
  paymentInfo: {
    editMode: false,
    address: {
      name: '',
      address1: '',
      address2: '',
      state: '',
      city: '',
      zipCode: '',
    },
    modeOfPayment: 'bank_account',
    bankAccount: {
      accountNumber: '',
      routingNumber: '',
    },
  },
  paymentSettings: {
    rentAmount: '',
    fee: '',
    totalAmount: '',
    accountName: '',
    accountType: 'card',
    accountLast4: '',
    frequency: 'Monthly',
    monthToMonth: false,
    numberOfPayments: 1,
    firstPaymentDate: '',
    setup: false,
  },
  requestStatus: {
    rentDetails: null,
    createRenter: null,
    paymentSettings: null,
    initiatePayment: null,
  },
  totalAmountForCreditCard: null,
  dateOfBirth: '',
  firstName: '',
  lastName: '',
};

const onboardingReducer = (state = initState, action: any = {}) => {
  switch (action.type) {
    case REQUEST_INITIATE_PAYMENT.INIT:
      return {
        ...state,
        requestStatus: {
          ...state.requestStatus,
          initiatePayment: requestStatus.INIT,
        },
      };
    case REQUEST_INITIATE_PAYMENT.SUCCESS:
      // TODO: the following conditional statement is a temporary fix
      // until the backend returns correct http statuses for errors
      return action.error || (action.payload && action.payload.error)
        ? {
            ...state,
            requestStatus: {
              ...state.requestStatus,
              initiatePayment: requestStatus.FAIL,
            },
          }
        : {
            ...state,
            requestStatus: {
              ...state.requestStatus,
              initiatePayment: requestStatus.SUCCESS,
            },
          };
    case REQUEST_INITIATE_PAYMENT.FAIL:
      return {
        ...state,
        requestStatus: {
          ...state.requestStatus,
          initiatePayment: requestStatus.FAIL,
        },
      };
    case REQUEST_CANCEL_SCHEDULED_PAYMENT.INIT:
      return {
        ...state,
        requestStatus: {
          ...state.requestStatus,
          cancelScheduledPayment: requestStatus.INIT,
        },
      };
    case REQUEST_CANCEL_SCHEDULED_PAYMENT.SUCCESS:
      // TODO: the following conditional statement is a temporary fix
      // until the backend returns correct http statuses for errors
      return action.error || (action.payload && action.payload.error)
        ? {
            ...state,
            requestStatus: {
              ...state.requestStatus,
              cancelScheduledPayment: requestStatus.FAIL,
            },
          }
        : {
            ...state,
            requestStatus: {
              ...state.requestStatus,
              cancelScheduledPayment: requestStatus.SUCCESS,
            },
          };
    case REQUEST_CANCEL_SCHEDULED_PAYMENT.FAIL:
      return {
        ...state,
        requestStatus: {
          ...state.requestStatus,
          cancelScheduledPayment: requestStatus.FAIL,
        },
      };
    case SAVE_PAYMENT_INFO:
      return {
        ...state,
        paymentInfo: {
          ...state.paymentInfo,
          ...action.paymentInfo,
        },
      };
    case EDIT_PAYMENT_INFO:
      return {
        ...state,
        paymentInfo: {
          ...state.paymentInfo,
          editMode: true,
        },
        requestStatus: {
          ...state.requestStatus,
          paymentSettings: null,
        },
      };
    case SAVE_DATE_OF_BIRTH:
      return {
        ...state,
        dateOfBirth: action.dateOfBirth,
      };
    case SAVE_FIRST_NAME:
      return {
        ...state,
        firstName: action.firstName,
      };
    case SAVE_LAST_NAME:
      return {
        ...state,
        lastName: action.lastName,
      };
    default:
      return state;
  }
};

export default onboardingReducer;
